import PropTypes from 'prop-types';
import React from 'react';

import './styles.scss';

const componentBaseClass = 'qoc-card';

function Card(props = {}) {
  const { children, isButton, onClickEvent, className } = props;

  if (isButton) {
    return (
      <button
        className={`card ${componentBaseClass} ${className}`}
        onClick={onClickEvent}
        type="button"
      >
        {children}
      </button>
    );
  }

  return (
    <div className={`card ${componentBaseClass} ${className}`}>{children}</div>
  );
}

Card.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  isButton: PropTypes.bool,
  onClickEvent: PropTypes.func,
  className: PropTypes.string
};

Card.defaultProps = {
  children: null,
  isButton: false,
  onClickEvent: {},
  className: ''
};

export default Card;
